import { BaseTransport } from '../transports'
import AdvancedBreadcrumbTransport from '../transports/common/advanced-breadcrumb-transport'
import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'
import { encodeToBase64 } from '../utils/encoding-utils'

class BreadcrumbClient {
    public async getBreadcrumbs({
        user,
        url,
    }: {
        user: RequestUserConfig
        url: string
    }): Promise<BaseTransport<AdvancedBreadcrumbTransport[]>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        try {
            const response = await NetworkService.get({
                url: '/api/breadcrumb/v1/srl',
                headers,
                params: {
                    requestPath: encodeToBase64(url),
                },
            })

            return response
        } catch (error) {
            const typedError = error as { status: number }
            return {
                data: null,
                status: typedError.status ?? 500,
            }
        }
    }
}

export default new BreadcrumbClient()
